import * as React from 'react';
import './Loader.css';

export type LoaderColor =
  | 'main'
  | 'accent'
  | 'action'
  | 'caution'
  | 'positive'
  | 'negative'
  | 'blue'
  | 'white'
  | 'black';

export interface LoaderProps extends React.HTMLAttributes<HTMLSpanElement> {
  className?: string;
  color?: LoaderColor;
}

export const Loader: React.FC<LoaderProps> = ({
  className,
  color = 'main',
  ...restSpanProps
}) => {
  const themeColors = new Set([
    'main',
    'accent',
    'action',
    'caution',
    'positive',
    'negative',
    'blue',
    'white',
    'black',
  ]);

  const isThemeColor = typeof color === 'string' && themeColors.has(color);

  const classes = [
    'em-c-loader-standard',
    isThemeColor && `em-c-loader-standard--${color}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');


  const fill = isThemeColor ? undefined : color;

  return (
    <span className={classes} {...restSpanProps}>
      <svg
        id="loader"
        width="100%"
        height="100%"
        viewBox="0 0 105 105"
        xmlns="http://www.w3.org/2000/svg"
        fill={fill}
        aria-hidden="true"
        role="img"
      >
        <circle cx="12.5" cy="12.5" r="12.5" className="circle-1"></circle>
        <circle cx="12.5" cy="52.5" r="12.5" className="circle-2"></circle>
        <circle cx="52.5" cy="12.5" r="12.5" className="circle-3"></circle>
        <circle cx="52.5" cy="52.5" r="12.5" className="circle-4"></circle>
        <circle cx="92.5" cy="12.5" r="12.5" className="circle-5"></circle>
        <circle cx="92.5" cy="52.5" r="12.5" className="circle-6"></circle>
        <circle cx="12.5" cy="92.5" r="12.5" className="circle-7"></circle>
        <circle cx="52.5" cy="92.5" r="12.5" className="circle-8"></circle>
        <circle cx="92.5" cy="92.5" r="12.5" className="circle-9"></circle>
      </svg>
    </span>
  );
};